import React from 'react';
import styled from 'styled-components';
import { EmptyStateSvg } from '../../../icons';
import { key } from 'styled-theme';

const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  margin-top: 2rem;
`;

const SvgWrapper = styled.div`
  margin-bottom: 1.5rem;
`;

const Description = styled.p`
  font-size: 1rem;
  margin-bottom: 1.5rem;
  line-height: 1.5;
`;

const ActionButton = styled.button`
  background-color: #3b82f6;
  color: white;
  font-weight: 500;
  padding: 12px 30px;
  font-size: 16px;
  border-radius: 50px;
  font-family: ${key('fonts.primary', 'JetBrains Mono Regular')};
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #4338ca;
  }

  &:focus-visible {
    outline: 2px solid #4f46e5;
    outline-offset: 2px;
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.4);
  }

  &:focus {
    outline: none;
  }
`;

const EmptyStateScreen = ({
  text = 'There are no applications to display at the moment.',
  buttonText = 'Add Item',
  onClick = () => {},

  ariaLabelButton,
}) => {
  return (
    <EmptyStateContainer role="region" aria-label="Empty state">
      <SvgWrapper>
        <EmptyStateSvg />
      </SvgWrapper>
      <Description>{text}</Description>
      {buttonText && (
        <ActionButton onClick={onClick} aria-label={ariaLabelButton || buttonText} tabIndex="0">
          {buttonText}
        </ActionButton>
      )}
    </EmptyStateContainer>
  );
};

export default EmptyStateScreen;
